import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class AppVersionGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'App Management',
            ROUTE_PATH.appVersion,
            ROUTE_PATH.appVersionForm,
            true,
            false,
            8,
            false,
            false,
            [],
            false,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            { evalKey: '', evalParam: [1], decisiveParam: false },
            false,
            false,
            false,
            null,
            { evalKey: 'null', evalParam: ["1"], decisiveParam: true },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: true,
                label: 'App Maintainence',
                isChecked: false
            },
            true,
            true,
            true,
            [],
            true,


        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const app_type = new Headers('App Type', 'app_type', false, true, 'text');
        const app_version = new Headers('Current Version', 'app_version', false, true, 'text');

        headers.push(app_type);
        headers.push(app_version);

        return headers;
    }
}